var map = {
  "./2025-06-dependency-management.mdx": [
    "./src/content/changelog/2025-06-dependency-management.mdx",
    "src_content_changelog_2025-06-dependency-management_mdx"
  ],
  "./2025-08-yearly-subscriptions.mdx": [
    "./src/content/changelog/2025-08-yearly-subscriptions.mdx",
    "src_content_changelog_2025-08-yearly-subscriptions_mdx"
  ],
  "./2025-04-version-statuses-devops.mdx": [
    "./src/content/changelog/2025-04-version-statuses-devops.mdx",
    "src_content_changelog_2025-04-version-statuses-devops_mdx"
  ],
  "./2025-07-akamai-integration-audit-logs.mdx": [
    "./src/content/changelog/2025-07-akamai-integration-audit-logs.mdx",
    "src_content_changelog_2025-07-akamai-integration-audit-logs_mdx"
  ],
  "./2025-01-timestamps-filters.mdx": [
    "./src/content/changelog/2025-01-timestamps-filters.mdx",
    "src_content_changelog_2025-01-timestamps-filters_mdx"
  ],
  "./2025-02-updated-navigation.mdx": [
    "./src/content/changelog/2025-02-updated-navigation.mdx",
    "src_content_changelog_2025-02-updated-navigation_mdx"
  ],
  "./2025-05-deployment-navigation.mdx": [
    "./src/content/changelog/2025-05-deployment-navigation.mdx",
    "src_content_changelog_2025-05-deployment-navigation_mdx"
  ]
};
function webpackAsyncContext(req) {
  if(!__webpack_require__.o(map, req)) {
    return Promise.resolve().then(function() {
      var e = new Error("Cannot find module '" + req + "'");
      e.code = 'MODULE_NOT_FOUND';
      throw e;
    });
  }

  var ids = map[req], id = ids[0];
  return __webpack_require__.e(ids[1]).then(function() {
    return __webpack_require__(id);
  });
}

webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = "./src/content/changelog lazy recursive ^\\.\\/.*\\.mdx$";
module.exports = webpackAsyncContext;
